(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    // ----- Helper: toggle a single FAQ item -----
    function toggleItem(item) {
      var isOpen = item.classList.contains('open');
      var btn = item.querySelector('.premium-faq__question-btn');
      var answer = item.querySelector('.premium-faq__answer');
      var content = answer ? answer.querySelector('.premium-faq__answer-content') : null;

      if (!btn || !answer || !content) return;

      if (isOpen) {
        // Close
        item.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0';
      } else {
        // Close all other open items in the same list
        var list = item.closest('.premium-faq__list');
        if (list) {
          var openItems = list.querySelectorAll('.premium-faq__item.open');
          openItems.forEach(function(other) {
            if (other !== item) {
              var otherBtn = other.querySelector('.premium-faq__question-btn');
              var otherAnswer = other.querySelector('.premium-faq__answer');
              other.classList.remove('open');
              if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
              if (otherAnswer) otherAnswer.style.maxHeight = '0';
            }
          });
        }

        // Open this one
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        // Set max-height to scrollHeight + a tiny buffer
        var height = content.scrollHeight + 1;
        answer.style.maxHeight = height + 'px';
      }
    }

    // ----- Initialise a single FAQ container -----
    function initFAQ(container) {
      // Prevent duplicate initialisation
      if (container.dataset.faqInitialized === 'true') return;
      container.dataset.faqInitialized = 'true';

      var items = container.querySelectorAll('.premium-faq__item');
      if (!items.length) return;

      // Bind click events to each question button
      items.forEach(function(item) {
        var btn = item.querySelector('.premium-faq__question-btn');
        if (btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            toggleItem(item);
          });
        }
      });

      // Handle resize: recalculate max-height for open items
      var resizeTimer;
      function handleResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          var openItems = container.querySelectorAll('.premium-faq__item.open');
          openItems.forEach(function(openItem) {
            var answer = openItem.querySelector('.premium-faq__answer');
            var content = answer ? answer.querySelector('.premium-faq__answer-content') : null;
            if (answer && content) {
              answer.style.maxHeight = content.scrollHeight + 1 + 'px';
            }
          });
        }, 200);
      }

      // Only attach resize listener once per container
      if (!container._resizeListener) {
        window.addEventListener('resize', handleResize);
        container._resizeListener = handleResize;
      }
    }

    // ----- Initialise all FAQ sections on the page -----
    function initAllFAQs() {
      var containers = document.querySelectorAll('[data-section-type="faq"]');
      containers.forEach(function(container) {
        initFAQ(container);
      });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFAQs);
    } else {
      initAllFAQs();
    }

    // ----- Re‑initialise on Shopify Theme Editor section reload -----
    document.addEventListener('shopify:section:load', function(event) {
      var target = event.target;
      if (!target) return;

      // The reloaded section might be the outer wrapper or an inner element.
      // Find the actual FAQ container inside.
      var container = target.closest && target.closest('[data-section-type="faq"]');
      if (!container) {
        // If the target itself has the attribute, use it
        if (target.hasAttribute && target.hasAttribute('data-section-type') && target.getAttribute('data-section-type') === 'faq') {
          container = target;
        } else {
          // Search within target
          container = target.querySelector && target.querySelector('[data-section-type="faq"]');
        }
      }

      if (container) {
        // Reset the initialized flag so we can re-bind events
        container.dataset.faqInitialized = 'false';
        // Also remove the resize listener reference to avoid duplicates
        if (container._resizeListener) {
          window.removeEventListener('resize', container._resizeListener);
          container._resizeListener = null;
        }
        // Re-initialize
        initFAQ(container);
      }
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
